import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab, styled } from '@material-ui/core';
import { colors } from '../../../style/colors';
import { filterIcons } from './assets';
import { useStyles } from './styles';

const StyledTabs = styled((props) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <div className="MuiTabs-indicatorSpan" /> }}
  />
))({
  '& .MuiTabs-indicator': {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  '& .MuiTabs-indicatorSpan': {
    width: '100%',
    height: '4px',
    marginLeft: '12px',
    marginRight: '12px',
    borderRadius: '4px',
    marginTop: '-2px',
    backgroundColor: colors.darkestBlue,
  },
  '& .MuiTabs-scroller': {
    borderBottom: 0,
  },
  '@media (hover: hover)': {
    '& .MuiTab-root:hover': {
      backgroundColor: colors.powderBlue,
      borderRadius: 8,
    },
  },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    marginRight: '16px',
    textTransform: 'none',
    width: 'auto',
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '16px',
    marginBottom: '4px',
    color: colors.darkestBlue,
    minWidth: 'auto',
    '&.Mui-selected': {
      color: colors.darkestBlue,
    },
    '&.Mui-focusVisible': {
      backgroundColor: colors.darkestBlue,
    },
  }),
);

const TopicFilter = ({
  availableTopics,
  onChange,
  topic,
  allTopicsLabel,
}: any) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const ALL_TILE = {
    id: 'allEvents',
    key: 'allEvents',
    ...(allTopicsLabel && { label: allTopicsLabel }),
  };

  return (
    <Box className={classes.tabs}>
      <StyledTabs
        scrollButtons={false}
        variant="scrollable"
        value={topic}
        onChange={onChange}
      >
        {[ALL_TILE, ...availableTopics].map((item) => (
          <StyledTab
            key={item.key}
            icon={filterIcons[item.key]}
            label={item?.label ?? t(`v2.global.chip_label_topic_${item.key}`)}
          />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default TopicFilter;
